import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ProjectionScreen = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.158 16.509c0-.986-.798-1.785-1.785-1.786H13.628c-.987 0-1.786.799-1.786 1.785v6.386c0 .986.799 1.785 1.786 1.785h72.746c.987 0 1.785-.799 1.785-1.785l-.001-6.385zm-6.132 13.15H17.974c-.986.001-1.785.8-1.785 1.786l.001.006-.001.003v37.154c0 2.201 1.857 3.982 4.152 3.982h27.17v5.373a4.067 4.067 0 0 0-1.599 3.222 4.09 4.09 0 1 0 8.178 0 4.065 4.065 0 0 0-1.601-3.223V72.59h27.17c2.294 0 4.152-1.781 4.152-3.982V31.412h-.003a1.786 1.786 0 0 0-1.782-1.753z"
  }));
});
ProjectionScreen.displayName = 'ProjectionScreen';
export var ProjectionScreenDimensions = {
  height: 100,
  width: 100
};